// extracted by mini-css-extract-plugin
export default {"text":"GamesGeoTab_text__i5l0T"};